import React, { useContext } from "react";
import axios from "axios";
import { useAlert } from "react-alert";

import { API_BASE_URL } from "../../../../constants";
import errorHandler from "../../../../hoc/ErrorHandler";
import context from "../../../../context/auth-context";
import UnlockForm from "./UnlockForm/UnlockForm";
import SystemCopyright from "../../../UI/SystemCopyright/SystemCopyright";

const LockScreen = () => {
  const authContext = useContext(context);
  const alert = useAlert();

  const screenUnlock = async (credentials) => {
    const response = await axios.post(
      "/auth/unlock-screen",
      { ...credentials, userId: authContext.userId },
      {
        headers: {
          "Company-Code": authContext.companyCode,
        },
      }
    );

    if (response) {
      credentials.password = null;
      window.$("#screenLockModal").modal("hide");
      window.$(".modal-backdrop").remove();
      document.getElementById("closeLockScreen").click();

      return alert.show(response.data.message, { type: "success" });
    }
  };

  return (
    <div
      className="modal fade modal-fill-in modal-slide-fall dismissible"
      id="screenLockModal"
      aria-hidden="false"
      role="dialog"
      tabIndex="-1"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-simple modal-danger">
        <div className="modal-content">
          <div className="modal-body">
            <div className="page-locked layout-full page-dark">
              <div
                className="page vertical-align text-center"
                data-animsition-in="fade-in"
                data-animsition-out="fade-out"
              >
                <div className="page-content vertical-align-middle">
                  <div className="avatar avatar-lg">
                    <img
                      src={`${API_BASE_URL}/auth/userimage/${authContext.userId}/${authContext.companyCode}`}
                      alt={authContext.userName}
                    />
                  </div>
                  <p className="locked-user">{authContext.userName}</p>
                  <UnlockForm screenUnlock={screenUnlock} />
                  <button
                    type="button"
                    className="btn btn-default btn-pure"
                    style={{ display: "none" }}
                    id="closeLockScreen"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <p>Screen locked. Enter password to unlock</p>
                  <p>
                    <a href="/" target="_blank" rel="noopener noreferrer">
                      Or sign in as a different user
                    </a>
                  </p>
                  <SystemCopyright lockScreen />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default errorHandler(LockScreen, axios);
